import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["hidden", "className"];
var __jsx = React.createElement;
import React from "react";
import MUIButton from "@mui/material/Button";
import Link from "next/link";
import UpRightIcon from "../Icons/UpRightIcon";
export var ELSButton = function ELSButton(_ref) {
  var hidden = _ref.hidden,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  if (hidden) {
    return null;
  }
  if (props.query) {
    return /*#__PURE__*/React.createElement(Link, {
      legacyBehavior: true,
      href: {
        pathname: props.href,
        query: props.query
      },
      passHref: true
    }, /*#__PURE__*/React.createElement(MUIButton, _extends({
      disableRipple: true,
      className: "es-button es-link ".concat(className || "")
    }, props), props.children, " ", props.outward ? /*#__PURE__*/React.createElement(UpRightIcon, null) : ""));
  }
  if (props.href) {
    return /*#__PURE__*/React.createElement(Link, {
      legacyBehavior: true,
      href: props.href,
      passHref: true
    }, /*#__PURE__*/React.createElement(MUIButton, _extends({
      disableRipple: true,
      className: "es-button es-link ".concat(className || "")
    }, props), props.children, " ", props.outward ? /*#__PURE__*/React.createElement(UpRightIcon, null) : ""));
  }
  return /*#__PURE__*/React.createElement(MUIButton, _extends({
    disableRipple: true,
    className: "es-button es-link ".concat(className || "")
  }, props), props.children);
};